// unsubscribeStreamViewerChannel.js
'use strict';
import getMeData from '../selector/getMeData.js';
import * as MessageTypes from '../serviceWorker/AppMessageTypes.js';
import { sendMessageToSW } from '../serviceWorker/helpers.js';
import { PRESET_SD } from '../resource/liveStreamConstants.js';

/**
 * Unsubscribe stream viewer channel
 * @kind action
 * @param {string} {streamId} - stream id.
 * @param {string} {preset} - stream preset.
 * @return {Promise} Action promise.
 */
const unsubscribeStreamViewerChannel =
  ({ streamId, preset = PRESET_SD }) =>
  async (dispatch, getState) => {
    const userId = getMeData(getState(), 'id');

    return sendMessageToSW({
      type: MessageTypes.UNSUBSCRIBE_STREAM_VIEWER_CHANNEL,
      payload: {
        streamId,
        preset,
        userId,
      },
    });
  };

export default unsubscribeStreamViewerChannel;
